/* =========================================================
   CUSTOM.JS - OPTIMIZED
   ========================================================= */

/* =========================================================
   MENU ITEM NAMES
   ========================================================= */

function cleanMenuItemNames() {
  document.querySelectorAll('.custom-sub-menu-child').forEach(function (item) {
    var text = item.textContent.trim();

    if (text.includes('_')) {
      item.textContent = text.split('_')[1];
    }
  });
}


/* =========================================================
   PAGINATION
   ========================================================= */

function cleanPagination() {
  var previousPagination = document.querySelectorAll('.previous-pagination');

  if (previousPagination.length >= 2) {
    var secondPaginationItem = document.querySelector(
      '.pagination__list li:nth-child(2)'
    );

    if (secondPaginationItem) {
      secondPaginationItem.remove();
    }
  }
}


/* =========================================================
   HAMBURGER MENU
   ========================================================= */

function initializeHamburger() {
  var toggle = document.getElementById('toggle');
  var overlay = document.getElementById('overlay');
  var buttonContainer = document.querySelector('.button_container');

  if (toggle && overlay) {
    toggle.addEventListener('click', function () {
      toggle.classList.toggle('active-menu');
      overlay.classList.toggle('open');
    });
  }

  if (buttonContainer) {
    buttonContainer.addEventListener('click', function () {
      document.body.classList.toggle('extra-class');
      document.documentElement.classList.toggle('overflow-hide');
    });
  }
}


/* =========================================================
   SWIPER SLIDER
   NOTE:
   This uses the OLD Swiper API currently used by the site.
   Do not change the Swiper JS version until this is migrated.
   ========================================================= */

function initializeSwiper() {
  if (
    typeof Swiper === 'undefined' ||
    !document.querySelector('.swiper-container')
  ) {
    return;
  }

  new Swiper('.swiper-container', {
    infinite: true,
    autoplay: false,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 5.4,
    paginationClickable: true,
    spaceBetween: 43,

    breakpoints: {
      1916: {
        slidesPerView: 4.4,
        spaceBetween: 43
      },

      1370: {
        slidesPerView: 3.4,
        spaceBetween: 20
      },

      860: {
        slidesPerView: 2.2,
        spaceBetween: 30
      },

      600: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },

      560: {
        slidesPerView: 1.5,
        spaceBetween: 20
      },

      440: {
        slidesPerView: 1.4,
        spaceBetween: 20
      },

      390: {
        slidesPerView: 1.1,
        spaceBetween: 20
      }
    }
  });
}


/* =========================================================
   SLICK SLIDERS
   ========================================================= */

function initializeSlickSliders() {
  if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
    return;
  }

  var $ = jQuery;

  var bestProducts = $('.best-col-prod');

  if (bestProducts.length && !bestProducts.hasClass('slick-initialized')) {
    bestProducts.slick({
      infinite: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,

      responsive: [
        {
          breakpoint: 870,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 772,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  var toddlerSlider = $('.toddler-slider');

  if (
    toddlerSlider.length &&
    !toddlerSlider.hasClass('slick-initialized')
  ) {
    toddlerSlider.slick({
      centerMode: true,
      centerPadding: '20px',
      slidesToShow: 4.6,
      arrows: false,
      autoplay: false,
      infinite: true,
      autoplaySpeed: 2000,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.6,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


/* =========================================================
   PRODUCT STOCK BUTTON
   ========================================================= */

function initializeStockButton() {
  var button = document.getElementById('add-to-cart-button');

  if (!button) {
    return;
  }

  var stockQuantity = parseInt(button.dataset.stock, 10);

  if (!isNaN(stockQuantity) && stockQuantity <= 0) {
    button.disabled = true;
    button.textContent = 'Out of Stock';
    button.style.cursor = 'not-allowed';
  }
}


/* =========================================================
   LEFT OFFSET
   Optimized:
   - Only runs on desktop
   - Uses requestAnimationFrame
   - Doesn't continuously calculate during resize
   ========================================================= */

var leftOffsetFrame = null;

function updateLeftOffset() {
  if (window.innerWidth <= 767) {
    var mobileContainers = document.querySelectorAll('.auto-container');

    mobileContainers.forEach(function (container) {
      container.style.paddingLeft = '';
    });

    return;
  }

  var leftOffset = document.querySelector('.left-offset');
  var containers = document.querySelectorAll('.auto-container');

  if (!leftOffset || !containers.length) {
    return;
  }

  var offset = leftOffset.getBoundingClientRect().left;

  containers.forEach(function (container) {
    container.style.paddingLeft = offset + 'px';
  });
}

function requestLeftOffsetUpdate() {
  if (leftOffsetFrame) {
    cancelAnimationFrame(leftOffsetFrame);
  }

  leftOffsetFrame = requestAnimationFrame(function () {
    updateLeftOffset();
    leftOffsetFrame = null;
  });
}


/* =========================================================
   MEGA MENU
   IMPORTANT:
   Original code initialized the menu again on every resize,
   which repeatedly added event listeners.
   This version initializes ONCE.
   ========================================================= */

function initializeMenu() {
  if (window.innerWidth < 769) {
    return;
  }

  var menuItems = document.querySelectorAll('.main-menu > li');

  menuItems.forEach(function (item) {
    var menuLinks = item.querySelectorAll('.sub-menu a');
    var productItems = item.querySelectorAll('.all-shirt-products > div');
    var menuHolder = item.querySelector('.sub-menu-main-holder');

    function deactivateItems() {
      productItems.forEach(function (productItem) {
        productItem.classList.remove('active');
      });
    }

    function activateFirstItem() {
      if (productItems.length) {
        productItems[0].classList.add('active');
      }
    }

    menuLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        deactivateItems();

        var targetId = link.getAttribute('data-id');

        if (!targetId) {
          return;
        }

        var targetItem = item.querySelector(targetId);

        if (targetItem) {
          targetItem.classList.add('active');
        }
      });
    });

    if (menuHolder) {
      menuHolder.addEventListener('mouseleave', function () {
        deactivateItems();
        activateFirstItem();
      });
    }

    activateFirstItem();
  });
}


/* =========================================================
   QUICK VIEW
   ========================================================= */

function initializeQuickView() {
  var quickViewButtons = document.querySelectorAll('.quick-view');
  var modal = document.getElementById('quick-view-modal');

  if (!quickViewButtons.length || !modal) {
    return;
  }

  var closeBtn = modal.querySelector('.close-quick-view');

  var sliderImages = [];
  var currentImageIndex = 0;

  function renderSliderImage() {
    var slider = modal.querySelector('.slider');

    if (!slider || !sliderImages.length) {
      return;
    }

    slider.innerHTML = '';

    var img = document.createElement('img');

    img.src = sliderImages[currentImageIndex];
    img.alt = 'Product image';
    img.loading = 'lazy';
    img.style.maxWidth = '100%';
    img.style.borderRadius = '8px';
    img.style.transition = 'opacity 0.3s ease-in-out';

    slider.appendChild(img);
  }

  function initImageSlider(images) {
    sliderImages = images;
    currentImageIndex = 0;

    renderSliderImage();
  }

  function updateQuickViewImage(image) {
    if (!image) {
      return;
    }

    var slider = modal.querySelector('.slider');

    if (!slider) {
      return;
    }

    slider.innerHTML = '';

    var img = document.createElement('img');

    img.src = image.src;
    img.alt = image.alt || 'Product image';
    img.loading = 'lazy';
    img.style.maxWidth = '100%';
    img.style.borderRadius = '8px';

    slider.appendChild(img);
  }

  /* Slider navigation */

  modal.addEventListener('click', function (event) {
    var nextButton = event.target.closest('.slider-next');
    var prevButton = event.target.closest('.slider-prev');

    if (nextButton && sliderImages.length) {
      currentImageIndex =
        (currentImageIndex + 1) % sliderImages.length;

      renderSliderImage();
    }

    if (prevButton && sliderImages.length) {
      currentImageIndex =
        (currentImageIndex - 1 + sliderImages.length) %
        sliderImages.length;

      renderSliderImage();
    }
  });

  /* Close button */

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      modal.style.display = 'none';
    });
  }

  /* Close by clicking outside */

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });

  /* Quick view buttons */

  quickViewButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      var productHandle =
        this.getAttribute('data-product-handle');

      if (!productHandle) {
        return;
      }

      /* Show modal immediately */
      modal.style.display = 'block';

      fetch('/products/' + productHandle + '.js')
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to load product');
          }

          return response.json();
        })

        .then(function (product) {
          var title = modal.querySelector(
            '.quick-view-product-title'
          );

          var price = modal.querySelector(
            '.quick-view-product-price'
          );

          var description = modal.querySelector(
            '.quick-view-product-description'
          );

          var variantInput = modal.querySelector(
            '.quick-view-product-id'
          );

          var atcButton = modal.querySelector(
            '.quick-view-add-to-cart'
          );

          var slider = modal.querySelector('.slider');
          var prevButton = modal.querySelector('.slider-prev');
          var nextButton = modal.querySelector('.slider-next');

          if (title) {
            title.textContent = product.title;
          }

          if (price) {
            price.textContent =
              '$' + (product.price / 100).toFixed(2);
          }

          if (description) {
            description.innerHTML = product.description;
          }

          if (variantInput && product.variants.length) {
            variantInput.value = product.variants[0].id;
          }

          /* Product tags */

          var productTags = (product.tags || []).map(function (tag) {
            return tag.toLowerCase();
          });

          if (atcButton) {
            if (productTags.includes('in-store')) {
              atcButton.disabled = true;
              atcButton.textContent = 'Available in store';
            } else {
              atcButton.disabled = false;
              atcButton.textContent = 'Add to Cart';
            }
          }

          /* Product images */

          if (slider) {
            var uniqueImages = [];
            var seenImages = new Set();

            product.variants.forEach(function (variant) {
              var image =
                variant.featured_image &&
                variant.featured_image.src;

              if (image && !seenImages.has(image)) {
                seenImages.add(image);
                uniqueImages.push(image);
              }
            });

            initImageSlider(uniqueImages);

            if (prevButton && nextButton) {
              var showControls = uniqueImages.length > 1;

              prevButton.style.display =
                showControls ? 'block' : 'none';

              nextButton.style.display =
                showControls ? 'block' : 'none';
            }
          }

          /* Product options */

          var variantsContainer = modal.querySelector(
            '.quick-view-variants'
          );

          var sizeContainer = modal.querySelector(
            '.quick-view-size-options'
          );

          if (!variantsContainer || !sizeContainer) {
            return;
          }

          variantsContainer.innerHTML = '';
          sizeContainer.innerHTML = '';

          var metafieldScript =
            document.getElementById(
              'product-colors-json-' + product.handle
            );

          var colors = [];

          if (metafieldScript) {
            try {
              colors = JSON.parse(
                metafieldScript.textContent
              );
            } catch (error) {
              console.warn(
                'Unable to parse product colors',
                error
              );
            }
          }

          var optionNames = product.options.map(function (option) {
            return option.name.toLowerCase();
          });

          var hasColor = optionNames.includes('color');
          var hasSize = optionNames.includes('size');

          var colorIndex =
            optionNames.indexOf('color') + 1;

          var sizeIndex =
            optionNames.indexOf('size') + 1;

          /* =====================================================
             COLOR OPTIONS
             ===================================================== */

          if (hasColor) {
            var colorList = document.createElement('ul');

            colorList.className = 'product-color-list';
            colorList.style.margin = '10px 0';
            colorList.style.padding = '0';

            var shownColors = new Set();
            var firstSwatchSelected = false;

            product.variants.forEach(function (variant) {
              var colorVal =
                variant['option' + colorIndex];

              if (
                !colorVal ||
                shownColors.has(colorVal.toLowerCase())
              ) {
                return;
              }

              shownColors.add(colorVal.toLowerCase());

              var li = document.createElement('li');

              li.style.display = 'inline-block';
              li.style.margin = '4px';

              var swatch = document.createElement('span');

              var metafieldColor = colors.find(function (color) {
                return (
                  color.name &&
                  color.name.toLowerCase() ===
                    colorVal.toLowerCase()
                );
              });

              var backgroundColor =
                metafieldColor &&
                metafieldColor.color
                  ? metafieldColor.color
                  : colorVal;

              swatch.className = 'color-swatch';
              swatch.style.backgroundColor =
                backgroundColor;

              swatch.title = colorVal;

              swatch.dataset.color =
                colorVal.toLowerCase();

              swatch.addEventListener(
                'click',
                function () {
                  var selectedColor =
                    colorVal.toLowerCase();

                  colorList
                    .querySelectorAll(
                      'span[data-color]'
                    )
                    .forEach(function (item) {
                      item.classList.remove('selected');
                    });

                  swatch.classList.add('selected');

                  var defaultVariant =
                    product.variants.find(function (v) {
                      var variantColor =
                        v['option' + colorIndex];

                      return (
                        variantColor &&
                        variantColor.toLowerCase() ===
                          selectedColor
                      );
                    });

                  if (!defaultVariant) {
                    return;
                  }

                  if (variantInput) {
                    variantInput.value =
                      defaultVariant.id;
                  }

                  /* Update image */

                  if (
                    defaultVariant.featured_image
                  ) {
                    updateQuickViewImage(
                      defaultVariant.featured_image
                    );
                  }

                  /* Update sizes */

                  var allSizes = [
                    ...new Set(
                      product.variants.map(function (v) {
                        return v['option' + sizeIndex];
                      })
                    )
                  ];

                  sizeContainer.innerHTML = '';

                  allSizes.forEach(function (sizeVal) {
                    if (!sizeVal) {
                      return;
                    }

                    var matchingVariant =
                      product.variants.find(
                        function (v) {
                          return (
                            v[
                              'option' + colorIndex
                            ] &&
                            v[
                              'option' + colorIndex
                            ].toLowerCase() ===
                              selectedColor &&
                            v[
                              'option' + sizeIndex
                            ] === sizeVal
                          );
                        }
                      );

                    var sizeButton =
                      document.createElement('button');

                    sizeButton.type = 'button';
                    sizeButton.textContent = sizeVal;
                    sizeButton.className =
                      'size-button';

                    if (matchingVariant) {
                      sizeButton.dataset.variantId =
                        matchingVariant.id;

                      if (!matchingVariant.available) {
                        sizeButton.disabled = true;
                        sizeButton.classList.add(
                          'unavailable'
                        );
                      }

                      sizeButton.addEventListener(
                        'click',
                        function () {
                          if (
                            !matchingVariant.available
                          ) {
                            return;
                          }

                          if (variantInput) {
                            variantInput.value =
                              matchingVariant.id;
                          }

                          sizeContainer
                            .querySelectorAll(
                              '.size-button'
                            )
                            .forEach(
                              function (button) {
                                button.classList.remove(
                                  'selected'
                                );
                              }
                            );

                          sizeButton.classList.add(
                            'selected'
                          );
                        }
                      );
                    } else {
                      sizeButton.disabled = true;
                      sizeButton.classList.add(
                        'unavailable'
                      );
                    }

                    sizeContainer.appendChild(
                      sizeButton
                    );
                  });

                  /* Update Add to Cart button */

                  if (atcButton) {
                    var anyAvailable =
                      Array.from(
                        sizeContainer.querySelectorAll(
                          '.size-button'
                        )
                      ).some(function (button) {
                        return !button.disabled;
                      });

                    if (anyAvailable) {
                      atcButton.disabled = false;
                      atcButton.textContent =
                        'Add to Cart';
                    } else {
                      atcButton.disabled = true;
                      atcButton.textContent =
                        'Notify When Available';
                    }
                  }
                }
              );

              li.appendChild(swatch);
              colorList.appendChild(li);

              if (!firstSwatchSelected) {
                swatch.click();
                firstSwatchSelected = true;
              }
            });

            variantsContainer.appendChild(colorList);
          }

          /* =====================================================
             SIZE ONLY
             ===================================================== */

          if (hasSize && !hasColor) {
            var sizeSet = new Set();

            product.variants.forEach(function (variant) {
              var sizeVal =
                variant['option' + sizeIndex];

              if (
                !sizeVal ||
                sizeSet.has(sizeVal)
              ) {
                return;
              }

              sizeSet.add(sizeVal);

              var matchingVariant =
                product.variants.find(function (v) {
                  return (
                    v['option' + sizeIndex] ===
                    sizeVal
                  );
                });

              var sizeButton =
                document.createElement('button');

              sizeButton.type = 'button';
              sizeButton.textContent = sizeVal;
              sizeButton.className = 'size-button';

              if (matchingVariant) {
                sizeButton.dataset.variantId =
                  matchingVariant.id;

                if (!matchingVariant.available) {
                  sizeButton.disabled = true;
                  sizeButton.classList.add(
                    'unavailable'
                  );
                }

                sizeButton.addEventListener(
                  'click',
                  function () {
                    if (
                      !matchingVariant.available
                    ) {
                      return;
                    }

                    if (variantInput) {
                      variantInput.value =
                        matchingVariant.id;
                    }

                    sizeContainer
                      .querySelectorAll(
                        '.size-button'
                      )
                      .forEach(
                        function (button) {
                          button.classList.remove(
                            'selected'
                          );
                        }
                      );

                    sizeButton.classList.add(
                      'selected'
                    );
                  }
                );
              }

              sizeContainer.appendChild(
                sizeButton
              );
            });
          }

          /* =====================================================
             QUICK VIEW QUANTITY
             ===================================================== */

          var quantityInput =
            modal.querySelector(
              '.quantity__input'
            );

          var minus =
            modal.querySelector(
              '.quantity-minus'
            );

          var plus =
            modal.querySelector(
              '.quantity-plus'
            );

          if (
            quantityInput &&
            minus &&
            plus
          ) {
            quantityInput.value = 1;

            function updateMinusButton() {
              minus.disabled =
                parseInt(
                  quantityInput.value,
                  10
                ) <= 1;
            }

            updateMinusButton();

            minus.onclick = function () {
              var value =
                parseInt(
                  quantityInput.value,
                  10
                ) || 1;

              if (value > 1) {
                quantityInput.value =
                  value - 1;
              }

              updateMinusButton();
            };

            plus.onclick = function () {
              var value =
                parseInt(
                  quantityInput.value,
                  10
                ) || 1;

              quantityInput.value =
                value + 1;

              updateMinusButton();
            };
          }
        })

        .catch(function (error) {
          console.error(
            'Quick view error:',
            error
          );

          modal.style.display = 'none';
        });
    });
  });
}


/* =========================================================
   CART
   ========================================================= */

function updateCartCount() {
  var cartCountElement =
    document.querySelector('.cart-count-bubble');

  /*
   * Don't make the request if there isn't a cart
   * counter on the current page.
   */
  if (!cartCountElement) {
    return;
  }

  fetch('/cart.js')
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    })

    .then(function (cart) {
      cartCountElement.textContent =
        cart.item_count;

      cartCountElement.style.display =
        cart.item_count > 0
          ? 'flex'
          : 'none';
    })

    .catch(function (error) {
      console.error(
        'Error fetching cart:',
        error
      );
    });
}


/* =========================================================
   ADD TO CART
   ========================================================= */

function initializeAddToCart() {
  document.querySelectorAll('.add-to-cart').forEach(
    function (button) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          var productId =
            this.getAttribute(
              'data-product-id'
            );

          if (!productId) {
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },

            body: JSON.stringify({
              id: productId,
              quantity: 1
            })
          })

            .then(function (response) {
              if (!response.ok) {
                throw new Error(
                  'Unable to add item to cart'
                );
              }

              return response.json();
            })

            .then(function () {
              updateCartCount();

              var notification =
                document.getElementById(
                  'cart-notification'
                );

              if (notification) {
                notification.style.display =
                  'block';

                setTimeout(
                  function () {
                    notification.style.display =
                      'none';
                  },
                  3000
                );
              }
            })

            .catch(function (error) {
              console.error(
                'Add to cart error:',
                error
              );
            });
        }
      );
    }
  );
}


/* =========================================================
   BUY NOW
   ========================================================= */

function initializeBuyNow() {
  document.querySelectorAll('.buy-now').forEach(
    function (button) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          var productId =
            this.getAttribute(
              'data-product-id'
            );

          if (!productId) {
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },

            body: JSON.stringify({
              id: productId,
              quantity: 1
            })
          })

            .then(function (response) {
              if (!response.ok) {
                throw new Error(
                  'Unable to add item to cart'
                );
              }

              return response.json();
            })

            .then(function () {
              window.location.href =
                '/checkout';
            })

            .catch(function (error) {
              console.error(
                'Buy now error:',
                error
              );
            });
        }
      );
    }
  );
}


/* =========================================================
   CART REMOVE / QUANTITY
   One unified handler instead of THREE separate handlers.
   ========================================================= */

function initializeCartActions() {
  document.addEventListener(
    'click',
    function (event) {
      var removeButton =
        event.target.closest(
          'cart-remove-button a'
        );

      var customRemoveButton =
        event.target.closest(
          '.cart__remove'
        );

      var button =
        removeButton ||
        customRemoveButton;

      if (!button) {
        return;
      }

      event.preventDefault();

      var lineItemKey =
        button.getAttribute(
          'data-cart-item-key'
        );

      /* Custom cart remove */

      if (lineItemKey) {
        fetch('/cart/change.js', {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json'
          },

          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0
          })
        })

          .then(function (response) {
            if (!response.ok) {
              throw new Error(
                'Unable to remove item'
              );
            }

            return response.json();
          })

          .then(function () {
            location.reload();
          })

          .catch(function (error) {
            console.error(
              'Error removing item:',
              error
            );
          });

        return;
      }

      /* Shopify cart remove */

      fetch(button.href, {
        method: 'GET'
      })

        .then(function () {
          location.reload();
        })

        .catch(function (error) {
          console.error(
            'Error removing item:',
            error
          );
        });
    }
  );


  /* Quantity changes */

  document.addEventListener(
    'change',
    function (event) {
      var quantityInput =
        event.target.closest(
          '.cart-quantity'
        );

      if (!quantityInput) {
        return;
      }

      var form =
        quantityInput.closest('form');

      if (!form) {
        return;
      }

      var formData =
        new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData
      })

        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Unable to update cart'
            );
          }

          return response;
        })

        .then(function () {
          location.reload();
        })

        .catch(function (error) {
          console.error(
            'Error updating quantity:',
            error
          );
        });
    }
  );
}


/* =========================================================
   INITIALIZE EVERYTHING ONCE
   ========================================================= */

function initializeCustomJS() {
  cleanMenuItemNames();
  cleanPagination();

  initializeHamburger();

  initializeSwiper();
  initializeSlickSliders();

  initializeStockButton();

  initializeMenu();
  initializeQuickView();

  initializeAddToCart();
  initializeBuyNow();
  initializeCartActions();

  /*
   * Only calculate left offset when actually needed.
   */
  updateLeftOffset();

  /*
   * Only request cart data if a cart counter exists.
   */
  updateCartCount();
}


/* =========================================================
   EVENTS
   ========================================================= */

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeCustomJS,
    { once: true }
  );
} else {
  initializeCustomJS();
}


/*
 * Optimized resize handler.
 *
 * The original code ran calculations on every single
 * resize event. This version waits until the browser
 * is ready to paint.
 */

window.addEventListener(
  'resize',
  requestLeftOffsetUpdate,
  { passive: true }
);